import { render } from "./FormAddMatch.vue?vue&type=template&id=dcc37f02&scoped=true"
import script from "./FormAddMatch.vue?vue&type=script&lang=js"
export * from "./FormAddMatch.vue?vue&type=script&lang=js"

import "./FormAddMatch.vue?vue&type=style&index=0&id=dcc37f02&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc37f02"]])

export default __exports__